export const Mobile = () => {
    return (
        <div>
            <h1 style={{color: "white"}}>
                Sorry, this page is not yet available on mobile devices. Please visit us on a desktop or laptop computer for the best experience.
            </h1>
        </div>
    );
}